var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,17h15c0.553,0,1-0.448,1-1s-0.447-1-1-1H12c-0.553,0-1,0.448-1,1S11.447,17,12,17z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#A1CEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,23H12c-0.553,0-1,0.448-1,1s0.447,1,1,1h34c0.553,0,1-0.448,1-1S46.553,23,46,23z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#A1CEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,31H12c-0.553,0-1,0.448-1,1s0.447,1,1,1h34c0.553,0,1-0.448,1-1S46.553,31,46,31z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#A1CEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,2H6C2.748,2,0,4.748,0,8v33c0,3.252,2.748,6,6,6h8v10c0,0.413,0.254,0.784,0.64,0.933C14.757,57.978,14.879,58,15,58   c0.276,0,0.547-0.115,0.74-0.327L25.442,47H54c3.252,0,6-2.748,6-6V8C60,4.748,57.252,2,54,2z M58,41c0,2.168-1.832,4-4,4H27.179   l3.579-4.161c0.36-0.418,0.313-1.05-0.105-1.41c-0.419-0.358-1.05-0.312-1.41,0.106l-4.982,5.792l0,0L16,54.414V46   c0-0.552-0.447-1-1-1H6c-2.168,0-4-1.832-4-4V8c0-2.168,1.832-4,4-4h48c2.168,0,4,1.832,4,4V41z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#A1CEF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.a827a3ce71a84dcafa9c394952af8435.svg";
export { ForwardRef as ReactComponent };